import React from "react";
import { FiEye } from "react-icons/fi";
import Modal from "newui/components/ui/Modal/Modal";

interface ImagePreviewModalProps {
	isOpen: boolean;
	previewUrl: string;
	title?: string;
	onClose: () => void;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
	isOpen,
	onClose,
	previewUrl,
	title = "Image Preview",
}) => (
	<Modal
		isOpen={isOpen}
		onClose={onClose}
		title={title}
		hideCloseButton={false}
		size="xl"
		closeOnOverlayClick
		closeOnEsc
		customIcon={<FiEye size={30} className="stroke-blue-500" />}
	>
		<div className="flex items-center justify-center">
			<img
				src={previewUrl}
				alt={title}
				className="max-h-[70vh] max-w-full rounded object-contain"
			/>
		</div>
	</Modal>
);
